export default {
  search: 'Buscar',
  rolesForUser: 'Roles para el usuario:',
  save: 'Guardar',
  warning: 'Advertencia',
  cannotBeUndone: 'Esta acción no se puede deshacer. ¿Estás seguro?',
  abort: 'Cancelar',
  confirm: 'Confirmar',
  processing: 'Procesando...',
  close: 'Cerrar',
  name: 'Nombre',
  lastname: 'Apellido',
  email: 'Correo electrónico',
  roles: 'Roles',
  role: 'Rol',
  description: 'Descripción',
  modelAccessManager: 'Puede gestionar el acceso al modelo para otros usuarios',
  ekrmManager: 'Puede gestionar los Modelos de Referencia de Conocimiento Experto (EKRM)',
  dataUploader: 'Puede subir datos para la Configuración del Modelo',
  onlyShowModelReport: 'Solo mostrar Reporte del Modelo en la navegación',
  externalUser: 'Usuario externo: solo puede ver planes que haya creado',
  diyModeler: 'Puede utilizar la funcionalidad de Modelos Automáticos (DIY Modeler)',
  rolesUpdated: 'Roles actualizados exitosamente',
  failedToUpdateRoles: 'Error al actualizar los roles. Por favor, intenta de nuevo.',
  errorUpdatingRoles: 'Ocurrió un error al actualizar los roles:'
}
